import React, { Component } from 'react'
import { 
  FormGroup, Col, InputGroup, 
  InputGroupAddon, ButtonDropdown, 
  DropdownToggle, DropdownMenu, 
  DropdownItem, Input, Button, } from 'reactstrap'
import forOwn from 'mout/object/forOwn'

/*
  <SetItemsFilterGenerator 
    filters={props.filters}
    setItemFilter={props.setItemFilter}
    removeItemFilter={props.removeItemFilter}
    filterBySelected={props.filterBySelected}
    filterText={props.filterText}
    handleFilterTextChange={props.handleFilterTextChange}
    handleFilterBySelectedChange={props.handleFilterBySelectedChange}
    resetFilterGenerator={props.resetFilterGenerator}
  />
*/


class SetItemsFilterGenerator extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dropdown: false,
    }
  }

  handleClickAddFilter() {
    if (this.props.filterText && this.props.filterBySelected) {
      this.props.setItemFilter(this.props.filterBySelected, this.props.filterText)
      this.props.resetFilterGenerator()
    } 
  }


  render() {

    // For the dropdown, compute only the filter categories not already used or selected
    const filterCategories = ['ContentType', 'SetType', 'ItemType', 'Name', 'QuestionText', 'Code', 'Node']
    let unusedFilterCategories = filterCategories.slice(0)
    if (this.props.filterBySelected) {
      const index = filterCategories.indexOf(this.props.filterBySelected)
      unusedFilterCategories.splice(index, 1)
    }
    let usedFilterCategories = []
    forOwn(this.props.filters, (val, key, o) => {
      if (val) {
        usedFilterCategories.push(key)
      }
    })
    if (usedFilterCategories !== []) {
      usedFilterCategories.forEach((usedFilterCategory) => {
        const index = unusedFilterCategories.indexOf(usedFilterCategory)
        unusedFilterCategories.splice(index, 1)
      })
    }

    // Create the dropdown items
    const dropdownItems = unusedFilterCategories.map((cat) => {
      return (
        <DropdownItem 
          key={`filterBy${cat}`}
          onClick={() => this.props.handleFilterBySelectedChange(cat)}
        >
          {cat}
        </DropdownItem>
      )
    })
    

    return (
      <FormGroup row>
        <Col md="12">
          <InputGroup>
            <InputGroupAddon addonType='prepend'>
              <ButtonDropdown isOpen={this.state.dropdown}
                              toggle={() => { this.setState({ dropdown: !this.state.dropdown }); }}
                              >
                <DropdownToggle 
                  caret color="primary"
                  disabled={usedFilterCategories.length >= filterCategories.length ? true : false}
                >
                  {this.props.filterBySelected ? this.props.filterBySelected : 'Filter By'}
                </DropdownToggle>
                <DropdownMenu className={this.state.dropdown ? "show" : ""}>
                  {dropdownItems}
                </DropdownMenu>
              </ButtonDropdown>
            </InputGroupAddon>
            <Input 
              type="text" 
              id="filterText" 
              name="filterText" 
              placeholder='Add filter text here...'
              value={this.props.filterText}
              onChange={(e) => this.props.handleFilterTextChange(e)}
              onKeyPress={(e) => e.key === 'Enter' ? this.handleClickAddFilter() : null}
              disabled={usedFilterCategories.length >= filterCategories.length ? true : false}
            />
            <InputGroupAddon addonType='append'>
              <Button 
                color='primary'
                onClick={() => this.handleClickAddFilter()}
                disabled={usedFilterCategories.length >= filterCategories.length || !this.props.filterText ? true : false}
              >
                <i className="fa fa-plus"></i>
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </Col>
      </FormGroup>
    )
  }
}

export default SetItemsFilterGenerator


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetItemsFilterGenerator.js